import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react'

import PendingTransaction from './PendingTransaction'

interface PendingTransactionModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit?: (token?: string) => void
  withCaptcha?: boolean
  autoSubmit?: boolean
}

const PendingTransactionModal = ({
  isOpen,
  onClose,
  onSubmit,
  withCaptcha,
  autoSubmit,
}: PendingTransactionModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={{ base: 'full', md: 'md' }}>
      <ModalOverlay />
      <ModalContent>
        <PendingTransaction
          isBroadcasting
          onClose={onClose}
          onSubmit={onSubmit}
          withCaptcha={withCaptcha}
          autoSubmit={autoSubmit}
        />
      </ModalContent>
    </Modal>
  )
}

export default PendingTransactionModal
